import { render, staticRenderFns } from "./AdminDepartmentIndexPageTableActions.vue?vue&type=template&id=e47097e2&"
import script from "./AdminDepartmentIndexPageTableActions.vue?vue&type=script&lang=ts&"
export * from "./AdminDepartmentIndexPageTableActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports